import { ContractType } from '../../../../common/types'

const rentalTerminology = {
  viewTitle: 'terminateContract:view.title',
  viewDescription: 'terminateContract:view.description',
  allTenantsMoveOutDescription:
    'terminateContract:texts.allTenantsMoveOutDescription',
  residentChangesTerminationInfo:
    'contractModification:residentChanges.terminationInfo',
  residentChangesTerminationLink:
    'contractModification:links.goToTerminateContract',
  moveOutContractPartyInfo: 'contractModification:texts.contractPartyMoveOut',
  formHeading: 'terminateContract:headings.rentalTermination',
  previewHeading: 'terminateContract:headings.terminationPreview',
  sentAfterConfirmation:
    'terminateContract:texts.terminationNoticeSentAfterConfirmation',
  returnFromAuthReminder:
    'terminateContract:texts.terminationReturnFromAuthReminder',
  beforeConfirmationInstruction:
    'terminateContract:texts.terminationNoticeBeforeConfirmationInstruction',
  instructions: 'terminateContract:texts.terminateInstructionsRental',
  submittedLabel: 'terminateContract:labels.terminated',
  reasonLabel: 'terminateContract:labels.terminationReason',
  suggestionAction: 'terminateContract:terminateSuggestions.terminate',
  additionalDetailsPlaceholder:
    'terminateContract:placeholders.additionalDetails',
  additionalDetailsInfo: 'terminateContract:texts.additionalDetailsInfo',
  confirmButton: 'terminateContract:buttons.confirmTermination',
  rejectButton: 'terminateContract:buttons.rejectTermination',
  confirmationRejectedHeading:
    'terminateContract:headings.confirmationRejected',
  confirmationAcceptedText: 'terminateContract:texts.confirmationAccepted',
  pendingTenantApprovalsDisallowedReason:
    'terminateContract:terminationDisallowedReason.pendingTerminationTenantApprovals',
  confirmationState: {
    confirmed: 'terminateContract:confirmationState.confirmed',
    pending: 'terminateContract:confirmationState.pending',
    rejected: 'terminateContract:confirmationState.rejected',
    notFound: 'terminateContract:confirmationState.notFound',
  },
} as const

const rightOfOccupancyTerminology = {
  viewTitle: 'terminateContract:view.rightOfOccupancyNoticeTitle',
  viewDescription: 'terminateContract:view.rightOfOccupancyNoticeDescription',
  allTenantsMoveOutDescription:
    'terminateContract:texts.rightOfOccupancyNoticeAllTenantsMoveOutDescription',
  residentChangesTerminationInfo:
    'contractModification:residentChanges.rightOfOccupancyNoticeInfo',
  residentChangesTerminationLink:
    'contractModification:links.goToRightOfOccupancyNotice',
  moveOutContractPartyInfo:
    'contractModification:texts.rightOfOccupancyNoticeContractPartyMoveOut',
  formHeading: 'terminateContract:headings.rightOfOccupancyNotice',
  previewHeading: 'terminateContract:headings.rightOfOccupancyNoticePreview',
  sentAfterConfirmation:
    'terminateContract:texts.rightOfOccupancyNoticeSentAfterConfirmation',
  returnFromAuthReminder:
    'terminateContract:texts.rightOfOccupancyNoticeReturnFromAuthReminder',
  beforeConfirmationInstruction:
    'terminateContract:texts.rightOfOccupancyNoticeBeforeConfirmationInstruction',
  instructions: 'terminateContract:texts.terminateInstructions',
  submittedLabel: 'terminateContract:labels.rightOfOccupancyNoticeSubmitted',
  reasonLabel: 'terminateContract:labels.rightOfOccupancyNoticeReason',
  suggestionAction:
    'terminateContract:terminateSuggestions.rightOfOccupancyNotice',
  additionalDetailsPlaceholder:
    'terminateContract:placeholders.rightOfOccupancyNoticeAdditionalDetails',
  additionalDetailsInfo:
    'terminateContract:texts.rightOfOccupancyNoticeAdditionalDetailsInfo',
  confirmButton: 'terminateContract:buttons.confirmRightOfOccupancyNotice',
  rejectButton: 'terminateContract:buttons.rejectRightOfOccupancyNotice',
  confirmationRejectedHeading:
    'terminateContract:headings.rightOfOccupancyNoticeConfirmationRejected',
  confirmationAcceptedText:
    'terminateContract:texts.rightOfOccupancyNoticeConfirmationAccepted',
  pendingTenantApprovalsDisallowedReason:
    'terminateContract:terminationDisallowedReason.rightOfOccupancyNoticePendingTenantApprovals',
  confirmationState: {
    confirmed:
      'terminateContract:confirmationState.rightOfOccupancyNoticeConfirmed',
    pending:
      'terminateContract:confirmationState.rightOfOccupancyNoticePending',
    rejected:
      'terminateContract:confirmationState.rightOfOccupancyNoticeRejected',
    notFound:
      'terminateContract:confirmationState.rightOfOccupancyNoticeNotFound',
  },
} as const

export const resolveContractTerminationTerminology = (
  contractType: ContractType
) =>
  contractType === ContractType.RIGHT_OF_OCCUPANCY
    ? rightOfOccupancyTerminology
    : rentalTerminology
